export const passwordRegexp = /[a-zA-Z0-9]{8,}$/;
